import { format } from "date-fns";
import { daysMonth } from "./calendar.constants";

interface FirstAndLastDate {
  firstDate: Date;
  lastDate: Date;
}

export const getFirstAndLastDateOfMonth = (date: Date): FirstAndLastDate => {
  const year = date.getFullYear();
  const month = date.getMonth();

  return {
    firstDate: new Date(year, month, 1),
    lastDate: new Date(year, month + 1, 0),
  };
};

export const fillEmptyArray = (num: number, days: daysMonth[]): daysMonth[] => {
  return Array(num)
    .fill({})
    .map((v, i) => ({
      isSelected: false,
      isWeekSelected: false,
      isDisabled: true,
      number: days.length + i + 1,
    }));
};

export const getMonthIndexAndName = (date: Date, strFormat = "M-MMMM yyyy") =>
  format(date, strFormat).split("-");

export const getDateBy = (date: Date, n: number) =>
  new Date(date.getFullYear(), date.getMonth(), n);
